import React, {useEffect, useState} from 'react';
import css from './Page404.module.scss'
import logo from '../../images/logo-text.svg'
import image404 from '../../images/404.svg'
import {NavLink, Redirect, withRouter} from "react-router-dom";
import {useTheme} from "../../App";
import {connect} from "react-redux";
import {setIsEmailConfirmed} from "../../redux/auth/auth-actions";
import {testAndConfirmEmail} from "../../redux/auth/auth-thunks";
import close from '../../images/close.svg'
import {getInvitation} from "../../redux/logbook/logbook-thunks";
import ConfirmEmailError from "../common/modals/ConfirmEmailError/ConfirmEmailError";
import {useTranslation} from "react-i18next";

const Page404 = ({history, location, ...props}) => {
  const {isDark} = useTheme()
  const {t} = useTranslation()
  useEffect(() => {
    if(location.pathname === '/confirm' && location.search.length > 0 && location.search.split('=')[0] === '?token') {
      props.testAndConfirmEmail(location.search.split('=')[1])
    }
  }, [])
  useEffect(() => {
    // console.log(location.pathname === '/invite' && location.search.length > 0 && location.search.split('=')[0] === '?invitation' && props.token)
    if(location.pathname === '/invite' && location.search.length > 0 && location.search.split('=')[0] === '?invitation' && props.token) {
      let invitation = location.search.split('&')[0].split('=')[1]
      let notification = location.search.split('&')[1].split('=')[1]
      console.log(invitation)
      props.getInvitation(invitation)
      localStorage.setItem('notification', notification)
    }
  }, [props.token])
  if(props.inviteTrip || props.isEmailConfirmed) {
    return <Redirect to={'/logbook'} />
  }
  return (
    <div className={`${css.p404} ${isDark && `${css.page404__dark}`}`}>
      {props.isConfirmError && <>
        <div className="overlay" />
        <ConfirmEmailError isDark={isDark} />
      </>}
      <img src={logo} alt="" className={css.logo}/>
      <img src={image404} alt="" />
      <p className={css.caption}>{t('page404')}</p>
      <NavLink to={props.token !== null ? '/logbook' : '/logbook/auth'} className={css.link}>
        {t('toMain')}
      </NavLink>
    </div>
  );
};

const mapStateToProps = (state) => ({
  token: state.authReducer.token,
  isEmailConfirmed: state.authReducer.isEmailConfirmed,
  isPasswordReseted: state.userReducer.isPasswordReseted,
  inviteTrip: state.logbookReducer.inviteTrip,
  isConfirmError: state.authReducer.isConfirmError
})

export default connect(mapStateToProps, {testAndConfirmEmail, getInvitation, setIsEmailConfirmed})(React.memo(withRouter(Page404)))
